import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import YouTube from 'react-youtube';
import { gsap } from 'gsap';

import Markdown from '../Markdown';

import './Hero.scss';

const Hero = ({ video, title, text, button }) => {
  const refHero = useRef();
  const refText = useRef();
  const refVideo = useRef();

  useEffect(() => {
    if (refHero) {
      if (refVideo) {
        gsap.from(refVideo.current, {
          opacity: 0,
          delay: 2.25,
          duration: 1,
        });
      }
      if (refText) {
        gsap.from(refText.current, {
          opacity: 0,
          x: 40,
          delay: 2.25,
          duration: 1,
        });
      }
    }
  }, []);

  return (
    <section ref={refHero} className={`hero`}>
      <Grid>
        <Row>
          <Col sm={12} lg={6} xl={7}>
            {video ? (
              <div ref={refVideo} className='hero__video'>
                <YouTube
                  videoId={video}
                  opts={{
                    playerVars: {
                      rel: 0,
                      showinfo: 0,
                      ecver: 2,
                    },
                  }}
                />
                {/* <Vimeo
                  video={video}
                  className="hero__video"
                  responsive={true}
                  showPortrait={false}
                  showTitle={false}
                  showByline={false}
                  color={"B5C5C5"}
                />  */}
              </div>
            ) : null}
          </Col>
          <Col sm={12} lg={5} lgOffset={1} xl={4}>
            <div className='hero__inner' ref={refText}>
              {title ? (
                <Markdown className='hero__title | title'>{title}</Markdown>
              ) : null}
              {text ? <Markdown className='hero__text'>{text}</Markdown> : null}
              {button ? (
                <a
                  className='hero__button | button'
                  href={button.url}
                  target='_blank'
                >
                  {button.text}
                </a>
              ) : null}
            </div>
          </Col>
        </Row>
      </Grid>
    </section>
  );
};

Hero.propTypes = {
  video: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  button: PropTypes.object,
};

Hero.defaultProps = {
  title: '',
  text: '',
};

export default Hero;
